import clsx from "clsx";
import { DetailedHTMLProps, FC, forwardRef, SelectHTMLAttributes } from "react";
import { SelectOption } from "./FormFields.interfaces";
import styles from "./FormFields.module.scss";

type Props = DetailedHTMLProps<
  SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
> & {
  options: SelectOption[];
  isEmptyFirstOption?: boolean;
  firstOptionTextForSelectField: string;
  disableEmptyOption?: boolean;
};

const Select: FC<Props> = forwardRef(
  ({ options, isEmptyFirstOption, ...props }, ref) => (
    <div className={clsx(styles.field, styles.select)}>
      <select {...props} ref={ref} id={props.name}>
        {!isEmptyFirstOption && props.firstOptionTextForSelectField && (
          <option value="" id="" disabled={props.disableEmptyOption}>
            {props.firstOptionTextForSelectField}
          </option>
        )}
        {isEmptyFirstOption && (
          <option value="" id="" disabled={props.disableEmptyOption}></option>
        )}
        {Array.isArray(options) &&
          options?.map((option, index) => (
            <option
              key={`${option.id}${index}`}
              value={option.value}
              id={option.id}
              disabled={option.disabled}
            >
              {option.value}
            </option>
          ))}
      </select>
      <div className={styles.tick}>
        <svg
          height="20"
          width="20"
          viewBox="0 0 8 12"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          focusable="false"
        >
          <path d="M2 0L.59 1.41 5.17 6 .59 10.59 2 12l6-6z"></path>
        </svg>
      </div>
    </div>
  )
);

Select.displayName = "Select";

export default Select;
